"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerCollection = void 0;
const tslib_1 = require("tslib");
const __1 = require("..");
const _1 = require(".");
/**
 * A specific logger that forwards its messages to a collection of loggers
 */
let LoggerCollection = class LoggerCollection extends _1.AbstractLogger {
    constructor() {
        super(...arguments);
        this.loggers = [];
    }
    addEntry(entry) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const promises = this.loggers.map((l) => l.addEntry(entry));
            yield Promise.all(promises);
        });
    }
    attachLogger(...loggers) {
        this.loggers.push(...loggers);
    }
};
LoggerCollection = tslib_1.__decorate([
    __1.Injectable({ lifetime: 'singleton' })
], LoggerCollection);
exports.LoggerCollection = LoggerCollection;
//# sourceMappingURL=logger-collection.js.map